<template>
  <div class="z-card pb-0 border-0">
    <h1 class="z-card__title">
      {{ $t('mailer.stats.general.block.main') }}
    </h1>

    <div class="z-card__body" style="position: relative">
      <column-chart :data="chart_data" :options="chart_options" />
    </div>
  </div>
</template>

<script>
  import { DATA } from '@/plugins/vuex-async-pagginate';
  import { mapGetters } from 'vuex';
  import { green, purple, red, yellow, light_grey, blue_grey } from '@shared/helpers/css';
  import ColumnChart from '@shared/components/stats-chart-column';

  export default {
    components: {
      ColumnChart
    },

    computed: {
      ...mapGetters('mailer/stats/general', { items: DATA }),
      chart_options() {
        return {
          series: {
            0: { color: green },
            1: { color: purple },
            2: { color: blue_grey },
            3: { color: red },
            4: { color: yellow },
            5: { color: light_grey }
          }
        };
      },
      columns() {
        let statuses = ['delivered', 'sent', 'not_delivered', 'failed', 'rejected', 'expired'];
        statuses = statuses.map(i => {
          return { label: this.$t(`mailer.message.status.${i}`), type: 'number' };
        });
        return ['', ...statuses];
      },

      chart_data() {
        const values = this.items.map(i => [
          i['caption'],
          i['delivered'],
          i['sent'],
          i['not_delivered'],
          i['failed'],
          i['rejected'],
          i['expired']
        ]);

        return [this.columns, ...values];
      }
    }
  };
</script>
